import { Conditions } from '../../view/components/conditions';
import { Logotipo } from './Logotipo';
import { MenuBar } from './Menu';
import { MenuMobile } from './MenuMobile';
import { Search } from './Search';
import {
    Content,
    Header,
    TopbarMenuCluster,
    TopbarSearchBox
} from './styles';

export const Nav = () => {
  return (
    <Header>
      <Content>
        <MenuMobile />
        <Logotipo />
        <TopbarSearchBox>
          <Search />
        </TopbarSearchBox>
        <TopbarMenuCluster>
          <MenuBar />
        </TopbarMenuCluster>
        <Conditions />
      </Content>
    </Header>
  )
}
